<template>
    <div>
        <el-row v-if="showSwitch && inboxForm.inbox.length > 0">
            <el-col>
                <h6>Mostrar Filtros</h6>
                <el-switch
                    v-model="showFilters"
                    active-text="Sí"
                    inactive-color="#13322B"
                    active-color="#9d2438"
                    inactive-text="">
                </el-switch>
            </el-col>
        </el-row>
        <br>
        <el-row v-if="showFilters">
            <el-form ref="form" :model="alias_this.filtersForm" label-width="120px" label-position="top">
                <el-row
                    v-if="alias_this.inbox.cat_category_id == 1 && filterProcedure(alias_this.inbox.cat_procedure_id, 1)"
                    :gutter="20">
                    <span>
                        <el-col :span="6">
                            <el-form-item label="No. Expediente"
                                          prop="record"
                                          :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                                <el-input
                                    v-model="alias_this.filtersForm.record"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Nombre"
                                          prop="name"
                                          :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                                <el-input
                                    v-model="alias_this.filtersForm.name"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Primer Apellido"
                                          prop="firstName"
                                          :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                                <el-input
                                    v-model="alias_this.filtersForm.firstName"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="Segundo Apellido"
                                          prop="secondName"
                                          :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                                <el-input
                                    v-model="alias_this.filtersForm.secondName"/>
                            </el-form-item>
                        </el-col>
                    </span>
                </el-row>
                <el-row v-if="alias_this.inbox.cat_category_id == 1 && filterProcedure(alias_this.inbox.cat_procedure_id, 2)">
                    <el-col :span="24">
                        <el-form-item label="Persona Moral"
                                      prop="moralPerson"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input
                                v-model="alias_this.filtersForm.moralPerson"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row v-if="alias_this.inbox.cat_category_id == 2" :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Fideicomisarios"
                                      prop="trustees"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input
                                v-model="alias_this.filtersForm.trustees"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Permiso"
                                      prop="permission"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input
                                v-model="alias_this.filtersForm.permission"/>
                        </el-form-item>
                    </el-col>


                </el-row>
                <el-row v-if="alias_this.inbox.cat_category_id == 3" :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="Persona Moral"
                                      prop="moralPerson"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input
                                v-model="alias_this.filtersForm.moralPerson"/>
                        </el-form-item>
                    </el-col>


                </el-row>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Folio"
                                      prop="folio"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input
                                v-model="alias_this.filtersForm.folio"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Estatus">
                            <el-select
                                filterable
                                clearable
                                v-model="alias_this.filtersForm.cat_status_id"
                                style="width: 100%"
                                placeholder="Seleccionar">
                                <el-option
                                    v-for="item in statuses"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Periodo"
                                      prop="dates"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-date-picker
                                v-model="alias_this.filtersForm.dates"
                                type="daterange"
                                range-separator="a"
                                start-placeholder="Inicio"
                                end-placeholder="Fin"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col>
                        <el-button
                            plain
                            type="primary"
                            icon="fas fa-search"
                            @click="filterData">
                            Filtrar
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
            <br>
            <el-row v-if="inboxForm.inbox.length > 0 && userInfo.cat_profile_id <= 3">
                <el-col :span="12">
                    <el-button @click="reportExcel" type="success" icon="fas fa-file-excel">
                        Exportar
                    </el-button>
                </el-col>
            </el-row>

        </el-row>


    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions, mapMutations} from 'vuex';
    import {Loading} from 'element-ui';

    export default {
        computed: {
            ...mapGetters('requests', {
                inboxForm: "inboxForm",
            }),
            ...mapState('requests', {
                filters: state => state.filters,
            }),
            userInfo() {
                return this.$store.state.user.user;
            },
        },
        props: {
            inbox: {
                type: Object,
                required: true
            },
            alias_this: {},
            search: {
                type: Function,
                required: true
            },

            procedures: {
                type: Array,
                required: true
            }
        },

        data() {
            return {
                activeName: null,
                countRequests: [],
                statuses: [],
                showFilters: false,
                showSwitch: true,
                form: {}
            }
        },

        created() {
            this.filters.arrayFilters = null;
            this.filters.arrayFilters = null;
            this.filters.countRequests = null
        },

        watch: {
            'inboxForm.inbox'(value) {
                if (value) {
                    this.getData();
                }
            }
        },

        methods: {
            getData() {
                if (this.inbox.cat_procedure_id && this.inbox.cat_procedure_id.length > 0) {
                    let params = {
                        ...this.inbox
                    };
                    axios.get('/api/make-filters', {params}).then(response => {
                        if (response.data.success) {
                            let _countRequest = [];
                            this.showSwitch = true;
                            this.filters.arrayFilters = response.data.filters;
                            this.filters.arrayFilters = _.groupBy(this.filters.arrayFilters, 'cat_procedure_id');
                            let _count = response.data.countRequests;

                            _count = _.groupBy(_count, function (item) {
                                return item.cat_procedure_id;
                            });
                            _.forEach(_count, function (value, key) {
                                _count[key] = _.groupBy(_count[key], function (item) {
                                    return item.cat_status_id;
                                });
                            });
                            this.filters.countRequests = _count;

                            this.statuses = response.data.statuses;
                        }
                    }).catch(e => {
                        console.log('error ', e)
                        this.hideLoading()
                    });
                }

            },
            showLoading(message) {
                this.$store.dispatch(
                    'loading/spinner',
                    {msg: message, status: true},
                    {root: true}
                );
            },
            hideLoading() {
                this.$store.dispatch('loading/spinner', {}, {root: true});
            },

            searchable(item) {
                item.consoleInbox = true;
                axios.post('/api/get-searchable', {...item}).then(response => {
                    if (response.data.success) {
                        this.inboxForm.inbox = response.data.searchable;
                    }
                })
            },

            filterProcedure(procedures, type){
                let _return = false;
                if(procedures && procedures.length > 0 && type == 1){
                    _.forEach(procedures, item => {
                        if(item == 1 || item == 2 || item == 4 || item == 5){
                            _return = true
                        }
                    })
                }
                if(procedures && procedures.length > 0 && type == 2){
                    _.forEach(procedures, item => {
                        if(item == 3 || item == 6){
                            _return = true
                        }
                    })
                }

                return _return;
            },

            filterData() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        //this.showLoading('Buscando registros');
                        let params = {
                            ...this.alias_this.inbox,
                            page: 1,
                            perPage: this.alias_this.perPage,
                            filters: this.alias_this.filtersForm
                        };
                        let loadingInstance = Loading.service({
                            lock: true,
                            text: 'Buscando, espere...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        axios.get('/api/get-my-requests', {params}).then(response => {
                            if (response.data.success) {
                                this.inboxForm.inbox = response.data.inbox.data;

                                /*this.alias_this.filtersForm.folio = null;
                                this.alias_this.filtersForm.cat_status_id = null;
                                this.alias_this.filtersForm.dates = null;
                                this.alias_this.filtersForm.name = null;
                                this.alias_this.filtersForm.firstName = null;
                                this.alias_this.filtersForm.secondName = null;
                                this.alias_this.filtersForm.trustees = null;
                                this.alias_this.filtersForm.record = null;
                                this.alias_this.filtersForm.moralPerson = null;*/
                                if (this.inboxForm.inbox.length == 0) {
                                    this.alias_this.notRequets = true;
                                } else {
                                    _.forEach(this.inboxForm.inbox, (item, key) => {
                                        if (item.data_form && item.data_form.length > 0) {
                                            _.orderBy(response.data.catalogs, ['name'], ['asc']);
                                            item.data_form = _.orderBy(item.data_form, ['data_info.order'], ['asc'])
                                        }
                                    })
                                }
                                this.alias_this.total = response.data.inbox.total;
                                this.alias_this.current_page = response.data.inbox.current_page;
                                //this.hideLoading();
                                loadingInstance.close();
                            } else {
                                //this.hideLoading();
                                this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                                loadingInstance.close();
                            }
                        }).catch(e => {
                            //this.hideLoading();
                            loadingInstance.close();
                            console.log('error filter ', e)
                            this.$store.dispatch('notifications/error', {msg: 'Error inesperado, trate nuevamente.'}, {root: true});
                        })

                    } else {
                        //this.hideLoading();
                        loadingInstance.close();
                        this.$store.dispatch('notifications/warning', {msg: 'Establezca un periodo de fechas'}, {root: true});
                    }
                })
            },
            reportExcel() {
                this.showLoading('Generando Excel...');
                let params = {
                    ...this.alias_this.inbox,
                    page: this.alias_this.currentPage,
                    perPage: this.alias_this.perPage,
                    filters: this.alias_this.filtersForm
                };
                axios.post('/api/report-excel', params, {responseType: 'blob'}).then(response => {
                    let now = new Date().toLocaleDateString();
                    const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = linkUrl;
                    link.setAttribute('download', `Reporte-SIPAC-${moment(new Date()).format('DD-MM-YYYY-HH:MM:SS')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    this.hideLoading()
                    this.$notify({
                        title: 'Éxito',
                        message: 'Fue generado el reporte en excel',
                        type: 'success'
                    });
                })
                    .catch(error => {
                        this.hideLoading();
                        this.$notify({
                            title: 'Error',
                            message: 'No fue posible realizar la descarga, inténtelo nuevamente.',
                            type: 'warning'
                        });
                    });

            }
        }
    }
</script>

<style scoped>

</style>
